/* eslint-disable no-unused-vars */
import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Contact from '../views/Contact.vue';
import AboutUs from '../views/AboutUs.vue';
import Process from '../views/Process.vue';
import Techno from '../views/Techno.vue';
import ClientReview from '../views/ClientReview.vue';
import Portfolio from '../views/Portfolio.vue';
import MobileDevelopment from '../views/MobileDevelopment/Main.vue';
import WebDevelopment from '../views/WebDevelopment/Main.vue';
import GameDevelopment from '../views/GameDevelopment/Main.vue';
import EnterpriseSolutions from '../views/EnterpriseSolutions/Main.vue';
import IosDevelopment from '../views/MobileDevelopment/IosDevelopment.vue';
import AndroidDevelopment from '../views/MobileDevelopment/AndroidDevelopment.vue';
import FlutterDevelopment from '../views/MobileDevelopment/FlutterDevelopment.vue';
import CrossPlatformDevelopment from '../views/MobileDevelopment/CrossPlatformDevelopment.vue';
import MobileDevelopmentMain from '../views/MobileDevelopment/MobileDevelopmentMain.vue';
import ARDevelopment from '../views/MobileDevelopment/ARDevelopment.vue';
import VRDevelopment from '../views/MobileDevelopment/VRDevelopment.vue';
import WebDevelopmentMain from '../views/WebDevelopment/WebDevelopmentMain.vue';
import PHPDevelopment from '../views/WebDevelopment/PHPDevelopment.vue';
import WordPressDevelopment from '../views/WebDevelopment/WordPressDevelopment.vue';
import CodeigniterDevelopment from '../views/WebDevelopment/CodeigniterDevelopment.vue';
import LaravelDevelopment from '../views/WebDevelopment/LaravelDevelopment.vue';
import AngularDevelopment from '../views/WebDevelopment/AngularDevelopment.vue';
import NodeDevelopment from '../views/WebDevelopment/NodeDevelopment.vue';
import AppCost from '../components/AppCost/AppCost.vue'

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/contact',
		name: 'Contact',
		component: Contact
	},
	{
		path: '/about-us',
		name: 'AboutUs',
		component: AboutUs
	},
	{
		path: '/process',
		name: 'Process',
		component: Process
	},
	{
		path: '/client-review',
		name: 'ClientReview',
		component: ClientReview
	},
	{
		// done
		path: '/technologies',
		name: 'Technologies',
		component: Techno
	},
	{
		// done
		path: '/portfolio',
		name: 'Portfolio',
		component: Portfolio
	},
	{
		path: '/mobile-development',
		name: 'MobileDevelopment',
		component: MobileDevelopmentMain,
		children: [
			{
				path: '',
				name: 'MobileDevelopment',
				component: MobileDevelopment
			},
			{
				path: 'iphone-development',
				name: 'IphoneDevelopment',
				component: IosDevelopment
			},
			{
				path: 'android-development',
				name: 'AndroidDevelopment',
				component: AndroidDevelopment
			},
			{
				path: 'flutter-development',
				name: 'FlutterDevelopment',
				component: FlutterDevelopment
			},
			{
				path: 'cross-platform-development',
				name: 'CrossPlatformDevelopment',
				component: CrossPlatformDevelopment
			},
			{
				path: 'augmented-reality-development',
				name: 'ARDevelopment',
				component: ARDevelopment
			},
			{
				path: 'virtual-reality-development',
				name: 'VRDevelopment',
				component: VRDevelopment
			}
		]
	},
	{
		path: '/web-development',
		name: 'WebDevelopmentMain',
		component: WebDevelopmentMain,
		children: [
			{
				path: '',
				name: 'WebDevelopment',
				component: WebDevelopment
			},
			{
				path: 'php-development',
				name: 'PHPDevelopment',
				component: PHPDevelopment
			},
			{
				path: 'wordpress-development',
				name: 'WordPressDevelopment',
				component: WordPressDevelopment
			},
			{
				path: 'codeigniter-development',
				name: 'CodeigniterDevelopment',
				component: CodeigniterDevelopment
			},
			{
				path: 'laravel-development',
				name: 'LaravelDevelopment',
				component: LaravelDevelopment
			},
			{
				path: 'angularjs-development',
				name: 'AngularDevelopment',
				component: AngularDevelopment
			},
			{
				path: 'nodejs-development',
				name: 'NodeDevelopment',
				component: NodeDevelopment
			},
		]
	},
	{
		path: '/game-development',
		name: 'GameDevelopment',
		component: GameDevelopment
	},
	{
		path: '/enterprise-solutions',
		name: 'EnterpriseSolutions',
		component: EnterpriseSolutions
	},
	{
		path: '/app-development-cost',
		name: 'AppCost',
		component: AppCost
	}
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
});


router.beforeEach((to, from, next) => {
	console.log('navigate', to, from)
	window.scrollTo({top: 0, behavior: 'smooth'});
	next();
})

export default router;
